export const CHANGE_EMAIL_REQUESTED = "CHANGE_EMAIL_REQUESTED";
export const CHANGE_EMAIL_RECEIVED = "CHANGE_EMAIL_RECEIVED";
export const CHANGE_EMAIL_REQUEST_FAILED = "CHANGE_EMAIL_REQUEST_FAILED";
export const CHANGE_EMAIL_REQUEST_RESET = "CHANGE_EMAIL_REQUEST_RESET";

export const CONFIRM_CHANGE_EMAIL_REQUESTED = "CONFIRM_CHANGE_EMAIL_REQUESTED";
export const CONFIRM_CHANGE_EMAIL_RECEIVED = "CONFIRM_CHANGE_EMAIL_RECEIVED";
export const CONFIRM_CHANGE_EMAIL_REQUEST_FAILED = "CONFIRM_CHANGE_EMAIL_REQUEST_FAILED";

export const requestChangeEmail = email => ({ type: CHANGE_EMAIL_REQUESTED, email });
export const receiveChangeEmail = () => ({ type: CHANGE_EMAIL_RECEIVED });
export const resetChangeEmail = () => ({ type: CHANGE_EMAIL_REQUEST_RESET });
export const errorChangeEmail = requestAction => ({
  type: CHANGE_EMAIL_REQUEST_FAILED,
  emailInUse: true,
  error: new Error("Failed to change email."),
  requestAction
});

export const requestConfirmChangeEmail = confirmationToken => ({
  type: CONFIRM_CHANGE_EMAIL_REQUESTED,
  confirmationToken
});
export const receiveConfirmChangeEmail = () => ({ type: CONFIRM_CHANGE_EMAIL_RECEIVED });
